import { useEffect, useState } from "react";
import { STAGE } from "@shared/taxonomy.js";
import { fundTypeKey, typeLabel } from "../lib/fundLabels.js";

/**
 * Khung trực quan đầu /nguon-von, vẽ từ SỐ LIỆU THẬT của danh mục (không phải
 * ví dụ): bao nhiêu nguồn vốn rót ở mỗi giai đoạn, và theo từng loại đơn vị.
 * Chạm một cột hoặc một thẻ là lọc danh sách bên dưới (gọi onChon), chạm lại
 * thì bỏ lọc. Cột "mọc" lên khi mở trang; HTML prerender đã có đủ cột.
 *
 * Một quỹ rót nhiều giai đoạn được đếm ở mỗi giai đoạn đó, nên tổng các cột
 * lớn hơn số nguồn vốn — nhãn ghi "nguồn vốn rót ở giai đoạn này".
 */
// Gạch nối không ngắt dòng (U+2011): cột hẹp trên điện thoại không tách "Pre-/seed".
const TEN_NGAN = { PRESEED: "Pre\u2011seed", SEED_PLUS: "Seed+", LATER: "Series B+" };

export default function NguonVonBanDo({ all, stage, type, onChon }) {
  const [moc, setMoc] = useState(true); // false trong khoảnh khắc đầu để cột mọc lên
  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;
    setMoc(false);
    const id = requestAnimationFrame(() => requestAnimationFrame(() => setMoc(true)));
    return () => cancelAnimationFrame(id);
  }, []);

  const theoGd = STAGE.list
    .map((s) => ({ id: s.id, ten: TEN_NGAN[s.id] || s.vi, so: all.filter((f) => f.thesis?.stages?.includes(s.id)).length }))
    .filter((x) => x.so > 0);
  const lonNhat = Math.max(1, ...theoGd.map((x) => x.so));
  const theoLoai = Object.entries(
    all.reduce((a, f) => { const k = fundTypeKey(f); if (k) a[k] = (a[k] || 0) + 1; return a; }, {}),
  ).sort((x, y) => y[1] - x[1]);
  const coDanhMuc = all.filter((f) => f.portfolio?.items?.length);
  const soDn = coDanhMuc.reduce((a, f) => a + f.portfolio.items.length, 0);

  return (
    <div className={`nvb${moc ? " moc" : ""}`}>
      <div className="nvb-dau">
        <span>{all.length} nguồn vốn theo giai đoạn</span>
        <span className="nvb-goi-y">Chạm để lọc</span>
      </div>
      <div className="nvb-cot" role="group" aria-label="Lọc theo giai đoạn">
        {theoGd.map((x, i) => (
          <button
            key={x.id}
            type="button"
            className={stage === x.id ? "dang" : stage ? "mo" : ""}
            aria-pressed={stage === x.id}
            aria-label={`${x.ten}: ${x.so} nguồn vốn rót ở giai đoạn này`}
            onClick={() => onChon("stage", stage === x.id ? "" : x.id)}
            style={{ "--ty": (x.so / lonNhat).toFixed(3), "--i": i }}
          >
            <b>{x.so}</b>
            <i aria-hidden="true" />
            <span>{x.ten}</span>
          </button>
        ))}
      </div>
      <div className="nvb-loai" role="group" aria-label="Lọc theo loại đơn vị">
        {theoLoai.map(([k, so]) => (
          <button
            key={k}
            type="button"
            className={type === k ? "dang" : ""}
            aria-pressed={type === k}
            onClick={() => onChon("type", type === k ? "" : k)}
          >
            {typeLabel(k)} <b>{so}</b>
          </button>
        ))}
      </div>
      {coDanhMuc.length > 0 && (
        <p className="nvb-chan">
          <b>{coDanhMuc.length}</b> quỹ công bố danh mục, <b>{soDn}</b> doanh nghiệp đã nhận vốn
        </p>
      )}
    </div>
  );
}
